<template>
    <div class="edit-table-canvas">
        <div class="edit-table-title">{{data_title}}</div>
        <div class="canvas_box" :style="{'width':table_width+'px','height':table_height+'px'}">
            <array-canvas  :data="data" :editable="editable==1 || editable==3"></array-canvas>
        </div>
        <div class="table_box" ref='table_box'>
            <array-table  :data="data" :cell_width='cell_width' :editable="editable==2 || editable==3"></array-table>
        </div>

    </div>
</template>

<script>
 import ArrayCanvas from './com/ArrayCanvas.vue';
 import ArrayTable from './com/ArrayTable.vue';


export default ({
    name:'EditTableCanvas',
    props:{
        data_title:String,
        data:Array,
        editable:Number,//0 无编辑模式 1 canvas编辑 2 table编辑 3 都可编辑
    },
    mounted() {
        //同步两高度
        setInterval(()=>{
            if(this.$refs?.table_box?.offsetWidth)this.table_width =this.$refs.table_box.offsetWidth;
            if(this.$refs?.table_box?.offsetHeight)this.table_height =this.$refs.table_box.offsetHeight;

        },1000);
        // setTimeout(()=>{
        //     console.log('data change')
        //     // this.data[0][0] = 0;
        //     this.$set(this.data[0],0,0);

        // },5000)

        //console.log(this.$refs.table_box);
    },
    data(){
        return {
            //data:[[1,0,0,0,1], [0,1,0,1,0], [0,0,1,0,0], [0,1,0,1,0], [1,0,0,0,1]],
            table_width:100,
            table_height:100,
            
        }
    },
    computed:{
        cell_width(){
            return '18px';
        }

    },
    watch:{

    },
    components:{
        ArrayCanvas,
        ArrayTable,
    }
})
</script>

<style lang="stylus" scoped>
.edit-table-canvas
    padding:0.5em;
    min-width:420px;
    min-height:200px;
    color:white
    border:1px solid rgba(255,255,255,0.1);
    display:inline-flex;
    justify-content: space-around;
    align-items: center;
    position relative
.edit-table-title
    position:absolute
    top:0%



.canvas_box
    border:1px solid transparent 
    margin:2px;

    &:hover
        border:1px solid green;

    & canvas
        min-width:30px;
        //min-height:30px;




</style>
